export enum BookingStatus {
  requested = 'requested',
  cancelled = 'cancelled',
  rejected = 'rejected',
  confirmed = 'confirmed',
  completed = 'completed',
  expired = 'expired',
}
